const QuizProgress = ({ total, current }) => {
  return (
    <div className="flex items-center justify-center gap-4">
      {Array.from({ length: total }, (_, i) => (
        <div
          key={i}
          className={`h-2 w-2 rounded-full transition-colors duration-300 ${
            i <= current ? 'bg-brand-400' : 'bg-white/25'
          }`}
        />
      ))}
    </div>
  );
};

export default QuizProgress;
